import React from 'react';
import i18next from 'i18next';
import TableCell from './cell';

export default function BooleanCell({ value, className }) {
  const translation = i18next.t(value ? 'yes' : 'no');

  return (
    <TableCell
      className={className}
      value={translation}
    />
  );
}
